<template>
  <div class="p-4 md:p-6">
    <!-- Encabezado -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div>
        <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Gestión de Cuotas de Crédito</h1>
        <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Administra las cuotas de crédito y sus pagos</p>
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full md:w-auto">
       
        <!-- BOTÓN DE REPORTE GENERAL -->
        <button
          @click="generarReporteGeneral"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:file-document" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Reporte General</span>
          <span class="sm:hidden">Reporte</span>
        </button>

        <!-- BOTÓN GENERAR CUOTAS (solo visible si hay venta seleccionada) -->
        <button
          v-if="ventaSeleccionada"
          @click="openGenerarCuotasModal"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:from-purple-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:calculator" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Generar Cuotas</span>
          <span class="sm:hidden">Generar</span>
        </button>
      </div>
    </div>

    <!-- Filtros y búsqueda -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-3 mb-4 border border-gray-200 dark:border-gray-700">
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 md:col-span-4">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Buscar Cuotas</label>
          <div class="relative">
            <Icon icon="mdi:magnify" class="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input v-model="searchQuery" type="text" placeholder="Factura, cliente, referencia..."
              class="w-full pl-8 pr-3 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent text-xs transition-all"
              @input="handleSearch" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-2">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Estado</label>
          <div class="relative">
            <select v-model="filterEstado" @change="handleFilterChange"
              class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
              <option value="all">Todos</option>
              <option value="PENDIENTE">Pendientes</option>
              <option value="PAGADO">Pagadas</option>
              <option value="VENCIDO">Vencidas</option>
              <option value="ANULADO">Anuladas</option>
            </select>
            <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-3">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Desde / Hasta</label>
          <div class="flex gap-1">
            <input v-model="fechaDesde" type="date"
              class="w-1/2 px-2 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-xs transition-all" />
            <input v-model="fechaHasta" type="date"
              class="w-1/2 px-2 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-xs transition-all" />
          </div>
        </div>
        <!-- Filtro Cliente eliminado por solicitud del usuario -->
      </div>

      <!-- BOTONES DE REPORTES POR FILTRO -->
      <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 flex flex-wrap gap-2">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300 mr-2 py-2">Reportes rápidos:</span>
        
        <button
          @click="generarReportePorFiltro('PENDIENTE', 'CUOTAS PENDIENTES')"
          class="px-3 py-1.5 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-lg text-xs font-medium hover:bg-yellow-100 dark:hover:bg-yellow-800/50 transition-colors border border-yellow-200 dark:border-yellow-800"
        >
          <Icon icon="mdi:clock-outline" class="mr-1 inline" /> Pendientes
        </button>
        
        <button
          @click="generarReportePorFiltro('PAGADO', 'CUOTAS PAGADAS')"
          class="px-3 py-1.5 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-lg text-xs font-medium hover:bg-green-100 dark:hover:bg-green-800/50 transition-colors border border-green-200 dark:border-green-800"
        >
          <Icon icon="mdi:check-circle" class="mr-1 inline" /> Pagadas
        </button>
        
        <button
          @click="generarReportePorFiltro('VENCIDO', 'CUOTAS VENCIDAS')"
          class="px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-lg text-xs font-medium hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors border border-red-200 dark:border-red-800"
        >
          <Icon icon="mdi:alert-circle" class="mr-1 inline" /> Vencidas
        </button>
        
        <button
          @click="generarReportePorFiltro('vencimiento-semana', 'CUOTAS A VENCER ESTA SEMANA')"
          class="px-3 py-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg text-xs font-medium hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors border border-blue-200 dark:border-blue-800"
        >
          <Icon icon="mdi:calendar-alert" class="mr-1 inline" /> Por vencer
        </button>
        
        <button
          @click="generarReportePorFiltro('mora', 'CUOTAS CON INTERESES DE MORA')"
          class="px-3 py-1.5 bg-orange-50 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 rounded-lg text-xs font-medium hover:bg-orange-100 dark:hover:bg-orange-800/50 transition-colors border border-orange-200 dark:border-orange-800"
        >
          <Icon icon="mdi:percent" class="mr-1 inline" /> Con intereses
        </button>
      </div>
    </div>

    <!-- GRID DE CUOTAS -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700">
      <div class="px-4 md:px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <div>
          <h2 class="text-base md:text-lg font-semibold text-gray-800 dark:text-white">Lista de Cuotas de Crédito</h2>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
            Mostrando {{ Math.min(paginatedCuotas.length, itemsPerPage) }} de {{ filteredCuotas.length }} cuotas
          </p>
        </div>
        <div class="flex items-center space-x-2 text-xs md:text-sm text-gray-500 dark:text-gray-400">
          <Icon icon="mdi:calendar" class="inline mr-1 text-sm" />
          <span class="hidden xs:inline">Última actualización:</span> {{ formatTime(lastUpdate) }}
        </div>
      </div>

      <div v-if="loading" class="py-12 md:py-16">
        <div class="flex flex-col items-center justify-center">
          <div class="animate-spin rounded-full h-10 w-10 md:h-12 md:w-12 border-t-2 border-b-2 border-blue-600 mb-4"></div>
          <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Cargando cuotas de crédito...</p>
        </div>
      </div>

      <div v-else-if="filteredCuotas.length === 0" class="py-12 md:py-16 px-4">
        <div class="flex flex-col items-center text-center">
          <div class="p-4 bg-gray-100 dark:bg-gray-700 rounded-full mb-4">
            <Icon icon="mdi:credit-card-off" class="text-3xl md:text-4xl text-gray-400" />
          </div>
          <h3 class="text-base md:text-lg font-medium text-gray-800 dark:text-white mb-2">
            No se encontraron cuotas de crédito
          </h3>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400 mb-6 max-w-md">
            {{ searchQuery || filterEstado !== 'all' || fechaDesde || fechaHasta
              ? 'Intenta con otros términos de búsqueda o cambia los filtros.' 
              : 'No hay cuotas de crédito registradas. Genera cuotas desde una venta a crédito.' }}
          </p>
          <button
            v-if="searchQuery || filterEstado !== 'all' || fechaDesde || fechaHasta"
            @click="clearFilters"
            class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm"
          >
            <Icon icon="mdi:filter-off" class="mr-2 inline" />
            Limpiar filtros
          </button>
          <button
            v-else
            @click="$router.push({ name: 'ventas', query: { tipo: 'credito' } })"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            <Icon icon="mdi:plus" class="mr-2 inline" />
            Ir a Ventas a Crédito
          </button>
        </div>
      </div>

      <div v-else class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider cursor-pointer" @click="toggleSort('numeroCuota')">
                Cuota
                <Icon v-if="sortBy === 'numeroCuota'" :icon="sortDirection === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down'" class="inline ml-1" />
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider cursor-pointer" @click="toggleSort('numeroFactura')">
                Factura
                <Icon v-if="sortBy === 'numeroFactura'" :icon="sortDirection === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down'" class="inline ml-1" />
              </th>

              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider cursor-pointer" @click="toggleSort('fechaVencimiento')">
                Vencimiento
                <Icon v-if="sortBy === 'fechaVencimiento'" :icon="sortDirection === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down'" class="inline ml-1" />
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider cursor-pointer" @click="toggleSort('montoUsd')">
                Monto
                <Icon v-if="sortBy === 'montoUsd'" :icon="sortDirection === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down'" class="inline ml-1" />
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider cursor-pointer" @click="toggleSort('saldoUsd')">
                Saldo
                <Icon v-if="sortBy === 'saldo_usd'" :icon="sortDirection === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down'" class="inline ml-1" />
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Estado
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
            <tr 
              v-for="cuota in paginatedCuotas" 
              :key="cuota.idCreditoCuota"
              class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
            >
              <td class="px-4 py-3 whitespace-nowrap">
                <span class="font-medium text-gray-900 dark:text-white">#{{ cuota.numeroCuota }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <span v-if="cuota.numeroFactura" class="text-gray-900 dark:text-white">{{ cuota.numeroFactura }}</span>
                <span v-else-if="cargandoVentas" class="text-gray-400 italic text-xs animate-pulse">Cargando...</span>
                <span v-else class="text-gray-400">N/A</span>
              </td>

              <td class="px-4 py-3 whitespace-nowrap">
                <div class="flex items-center">
                  <Icon :icon="estaVencida(cuota) ? 'mdi:alert-circle' : 'mdi:calendar'" 
                        :class="estaVencida(cuota) ? 'text-red-500 mr-1.5' : 'text-gray-400 mr-1.5'" 
                        class="text-sm" />
                  <span :class="estaVencida(cuota) ? 'text-red-600 dark:text-red-400 font-medium' : ''">
                    {{ formatDate(cuota.fechaVencimiento, false) }}
                  </span>
                </div>
                <div v-if="cuota.diasVencidos > 0" class="text-xs text-red-500 mt-1">
                  {{ cuota.diasVencidos }} días vencido
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div class="font-medium text-gray-900 dark:text-white">
                  $ {{ formatNumber(cuota.montoUsd) }}
                </div>
                <div class="text-xs text-gray-500 dark:text-gray-400">
                  Bs {{ formatNumber(cuota.montoBs) }}
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div v-if="cuota.saldoUsd > 0" class="font-medium text-yellow-600 dark:text-yellow-400">
                  $ {{ formatNumber(cuota.saldoUsd) }}
                </div>
                <div v-else class="font-medium text-green-600 dark:text-green-400">
                  Pagado
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <span
                  @click="abrirModalToggleStatus(cuota)"
                  :class="[
                    'px-2 py-1 text-xs font-semibold rounded-full inline-flex items-center cursor-pointer',
                    obtenerColorEstado(cuota.estado)
                  ]"
                >
                  <Icon :icon="obtenerIconoEstado(cuota.estado)" class="mr-1 text-xs" />
                  {{ convertirEstadoATexto(cuota.estado) }}
                </span>
                <div v-if="cuota.interesMoraUsd > 0" class="text-xs text-orange-600 dark:text-orange-400 mt-1">
                  + ${{ formatNumber(cuota.interesMoraUsd) }} interés
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div class="flex items-center space-x-1">
                  <button
                    v-if="cuota.estado !== 'PAGADO' && cuota.estado !== 'ANULADO'"
                    @click.stop="abrirModalPagar(cuota)"
                    class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-100 dark:hover:bg-green-800/50 transition-colors"
                    title="Registrar pago"
                  >
                    <Icon icon="mdi:cash" class="text-base md:text-lg" />
                  </button>
                  <button
                    v-if="cuota.estado !== 'PAGADO' && cuota.estado !== 'ANULADO'"
                    @click.stop="abrirModalPagarParcial(cuota)"
                    class="p-2 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400 rounded-lg hover:bg-yellow-100 dark:hover:bg-yellow-800/50 transition-colors"
                    title="Pago parcial"
                  >
                    <Icon icon="mdi:cash-multiple" class="text-base md:text-lg" />
                  </button>
                  <button
                    @click.stop="abrirModalVerDetalles(cuota)"
                    class="p-2 bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-800/50 transition-colors"
                    title="Ver detalles"
                  >
                    <Icon icon="mdi:eye" class="text-base md:text-lg" />
                  </button>
                  <button
                    v-if="cuota.estado !== 'ANULADO'"
                    @click.stop="abrirModalEditar(cuota)"
                    class="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors"
                    title="Editar"
                  >
                    <Icon icon="mdi:pencil" class="text-base md:text-lg" />
                  </button>
                  <button
                    v-if="cuota.estado !== 'ANULADO' && cuota.estado !== 'PAGADO'"
                    @click.stop="abrirModalAnular(cuota)"
                    class="p-2 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                    title="Anular"
                  >
                    <Icon icon="mdi:cancel" class="text-base md:text-lg" />
                  </button>
                  <button
                    v-if="esAdmin"
                    @click.stop="eliminarCuota(cuota)"
                    class="p-2 bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-300 rounded-lg hover:bg-red-700 hover:text-white transition-all shadow-sm"
                    title="Eliminar Permanente (Administrador)"
                  >
                    <Icon icon="mdi:trash-can-outline" class="text-base md:text-lg" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
          <div class="flex flex-wrap gap-4 justify-between items-center">
            <div class="text-sm text-gray-700 dark:text-gray-300">
              <span class="font-medium">Totales:</span>
              <span class="ml-4">$ {{ formatNumber(resumenTotales.totalPorCobrarUSD) }} por cobrar</span>
              <span class="ml-4">$ {{ formatNumber(resumenTotales.totalPagadoUSD) }} pagado</span>
              <span v-if="resumenTotales.totalInteresesMoraUSD > 0" class="ml-4 text-orange-600">
                $ {{ formatNumber(resumenTotales.totalInteresesMoraUSD) }} intereses
              </span>
            </div>
            <div class="text-sm text-gray-700 dark:text-gray-300">
              <span class="font-medium">Resumen:</span>
              <span class="ml-4 text-yellow-600">Pendientes: {{ resumenTotales.cuotasPendientes }}</span>
              <span class="ml-4 text-green-600">Pagadas: {{ resumenTotales.cuotasPagadas }}</span>
              <span class="ml-4 text-red-600">Vencidas: {{ resumenTotales.cuotasVencidas }}</span>
            </div>
          </div>
        </div>

        <!-- Paginación Premium -->
        <div v-if="filteredCuotas.length > itemsPerPage" class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div class="text-xs text-gray-500 dark:text-gray-400 order-2 sm:order-1">
            Mostrando <span class="font-semibold text-gray-700 dark:text-gray-300">{{ startItem }}–{{ Math.min(endItem, filteredCuotas.length) }}</span> de <span class="font-semibold text-gray-700 dark:text-gray-300">{{ filteredCuotas.length }}</span>
          </div>
          <div class="flex items-center gap-1 order-1 sm:order-2">
            <button @click="currentPage = Math.max(currentPage - 1, 1)" :disabled="currentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-left" class="text-base" />
            </button>
            <button v-for="page in visiblePages" :key="page" @click="currentPage = page"
              :class="['w-8 h-8 flex items-center justify-center rounded-lg text-xs font-semibold transition-all',
                currentPage === page
                  ? 'bg-blue-600 text-white shadow-sm shadow-blue-300 dark:shadow-blue-900'
                  : 'border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700']">{{ page }}</button>
            <button @click="currentPage = Math.min(currentPage + 1, totalPages)" :disabled="currentPage === totalPages"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-right" class="text-base" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PARA CREAR/EDITAR CUOTA -->
    <Teleport to="body">
    <div v-if="showModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="p-2 rounded-xl bg-gradient-to-r from-purple-500 to-indigo-500 shadow-md mr-3">
                <Icon :icon="editingCuota ? 'mdi:pencil-box' : 'mdi:calculator'" class="text-white text-xl" />
              </div>
              <div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white">
                  {{ editingCuota ? 'Editar Cuota' : 'Nueva Cuota' }}
                </h3>
                <p class="text-xs text-gray-600 dark:text-gray-400">
                  {{ editingCuota ? 'Modifica los datos de la cuota' : 'Completa los datos para crear una nueva cuota' }}
                </p>
              </div>
            </div>
            <button 
              @click="closeModal"
              class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>
        
        <form @submit.prevent="saveCuota" class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  ID Venta <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.idVenta"
                  type="number"
                  required
                  min="1"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="ID de la venta"
                />
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Número de Cuota <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.numeroCuota"
                  type="number"
                  required
                  min="1"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                />
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Fecha de Vencimiento <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.fechaVencimiento"
                type="date"
                required
                :min="minDate"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
              />
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Monto USD <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.montoUsd"
                  type="number"
                  step="0.01"
                  min="0.01"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Monto Bs
                </label>
                <input
                  v-model="form.montoBs"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Saldo USD
                </label>
                <input
                  v-model="form.saldoUsd"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
                <p class="text-xs text-gray-500 mt-1">Si está vacío, se usará el monto USD</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Saldo Bs
                </label>
                <input
                  v-model="form.saldoBs"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Interés Mora USD
                </label>
                <input
                  v-model="form.interesMoraUsd"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Interés Mora Bs
                </label>
                <input
                  v-model="form.interesMoraBs"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Observaciones
              </label>
              <textarea
                v-model="form.observaciones"
                rows="2"
                maxlength="500"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 resize-none text-sm"
                placeholder="Observaciones adicionales..."
              ></textarea>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Estado
              </label>
              <div class="flex space-x-4">
                <label class="flex items-center">
                  <input type="radio" v-model="form.estado" value="PENDIENTE" class="mr-2">
                  <span class="text-sm">Pendiente</span>
                </label>
                <label class="flex items-center">
                  <input type="radio" v-model="form.estado" value="PAGADO" class="mr-2">
                  <span class="text-sm">Pagado</span>
                </label>
                <label class="flex items-center">
                  <input type="radio" v-model="form.estado" value="VENCIDO" class="mr-2">
                  <span class="text-sm">Vencido</span>
                </label>
              </div>
            </div>
          </div>
          
          <div class="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              @click="closeModal"
              class="px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="saving || !isFormValid"
              class="px-4 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-medium hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <Icon v-if="saving" icon="mdi:loading" class="animate-spin mr-2 inline" />
              {{ saving ? 'Guardando...' : (editingCuota ? 'Actualizar' : 'Crear') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE PAGO DE CUOTA -->
    <Teleport to="body">
    <div v-if="showPagoModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-lg transform transition-all duration-300 scale-100 mx-auto my-auto overflow-hidden">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-green-600 to-emerald-600">
          <div class="flex items-center justify-between text-white">
            <div class="flex items-center">
              <Icon icon="mdi:cash" class="text-2xl mr-3" />
              <div>
                <h3 class="text-lg font-bold">Registrar Pago</h3>
                <p class="text-xs text-green-100">Cuota #{{ pagoCuota?.numero_cuota }} - {{ pagoCuota?.numero_factura }}</p>
              </div>
            </div>
            <button @click="closePagoModal" class="p-2 hover:bg-white/30 rounded-lg transition-colors">
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>

        <div class="px-6 py-4">
          <div class="mb-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <div class="grid grid-cols-2 gap-3">
              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400">Monto de cuota</p>
                <p class="font-semibold text-gray-900 dark:text-white">$ {{ formatNumber(pagoCuota?.monto_usd) }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400">Saldo pendiente</p>
                <p class="font-semibold text-yellow-600 dark:text-yellow-400">$ {{ formatNumber(pagoCuota?.saldo_usd) }}</p>
              </div>
              <div v-if="pagoInteresMora > 0" class="col-span-2">
                <p class="text-xs text-gray-500 dark:text-gray-400">Interés de mora calculado</p>
                <p class="font-semibold text-orange-600 dark:text-orange-400">$ {{ formatNumber(pagoInteresMora) }}</p>
              </div>
            </div>
          </div>

          <form @submit.prevent="procesarPago">
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Monto a pagar (USD) <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="pagoForm.montoUsdPagado"
                  type="number"
                  step="0.01"
                  min="0.01"
                  :max="pagoCuota?.saldoUsd + pagoInteresMora"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
                <p class="text-xs text-gray-500 mt-1">Máximo: $ {{ formatNumber(pagoCuota?.saldoUsd + pagoInteresMora) }}</p>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Monto en Bs
                </label>
                <input
                  v-model="pagoForm.montoBsPagado"
                  type="number"
                  step="0.01"
                  min="0"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Fecha de pago <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="pagoForm.fechaPago"
                  type="date"
                  required
                  :max="today"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 text-sm"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Método de pago <span class="text-red-500">*</span>
                </label>
                <select
                  v-model="pagoForm.idMetodoPago"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 text-sm"
                >
                  <option value="">Seleccionar...</option>
                  <option v-for="metodo in metodosPago" :key="metodo.idMetodoPago" :value="metodo.idMetodoPago">
                    {{ metodo.nombre }}
                  </option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Referencia
                </label>
                <input
                  v-model="pagoForm.referencia"
                  type="text"
                  maxlength="100"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="Número de referencia"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Observaciones
                </label>
                <textarea
                  v-model="pagoForm.observaciones"
                  rows="2"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none transition-all duration-300 resize-none text-sm"
                  placeholder="Observaciones del pago..."
                ></textarea>
              </div>

              <label class="flex items-center space-x-2">
                <input type="checkbox" v-model="pagoForm.aplicar_interes_mora" class="rounded border-gray-300 text-green-600 focus:ring-green-500">
                <span class="text-sm">Aplicar interés de mora calculado</span>
              </label>
            </div>

            <div class="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                @click="closePagoModal"
                class="px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="pagoSaving || !pagoFormValid"
                class="px-4 py-2.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              >
                <Icon v-if="pagoSaving" icon="mdi:loading" class="animate-spin mr-2 inline" />
                {{ pagoSaving ? 'Procesando...' : (pagoEsParcial ? 'Registrar Pago Parcial' : 'Registrar Pago Completo') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE DETALLES DE CUOTA -->
    <Teleport to="body">
    <div v-if="showDetallesModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-3xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-purple-600 to-indigo-600">
          <div class="flex items-center justify-between text-white">
            <div class="flex items-center">
              <Icon icon="mdi:credit-card" class="text-2xl mr-3" />
              <div>
                <h3 class="text-lg font-bold">Detalles de Cuota #{{ detalleCuota?.numeroCuota }}</h3>
                <p class="text-xs text-purple-100">Factura: {{ detalleCuota?.numeroFactura }}</p>
              </div>
            </div>
            <button @click="closeDetallesModal" class="p-2 hover:bg-white/30 rounded-lg transition-colors">
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>

        <div class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div v-if="cargandoDetalles" class="flex justify-center py-8">
            <div class="animate-spin rounded-full h-8 w-8 border-2 border-blue-600 border-t-transparent"></div>
          </div>
          <div v-else-if="detalleCuota" class="space-y-4">
            <!-- Información básica -->
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">ID Cuota</p>
                <p class="text-sm font-semibold">{{ detalleCuota.idCuota }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">ID Venta</p>
                <p class="text-sm font-semibold">{{ detalleCuota.idVenta }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">N° Cuota</p>
                <p class="text-sm font-semibold">{{ detalleCuota.numeroCuota }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
                <p class="text-sm">
                  <span :class="[
                    'px-2 py-1 text-xs font-semibold rounded-full inline-block',
                    obtenerColorEstado(detalleCuota.estado)
                  ]">
                    {{ convertirEstadoATexto(detalleCuota.estado) }}
                  </span>
                </p>
              </div>
            </div>

            <!-- Información del cliente -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Información del Cliente</p>
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <p class="text-xs text-gray-500">Nombre</p>
                  <p class="text-sm font-medium">{{ detalleCuota.nombreCliente }}</p>
                </div>
                <div v-if="detalleCuota.telefonoCliente">
                  <p class="text-xs text-gray-500">Teléfono</p>
                  <p class="text-sm">{{ detalleCuota.telefonoCliente }}</p>
                </div>
                <div v-if="detalleCuota.emailCliente" class="col-span-2">
                  <p class="text-xs text-gray-500">Email</p>
                  <p class="text-sm">{{ detalleCuota.emailCliente }}</p>
                </div>
              </div>
            </div>

            <!-- Información de la venta -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Información de la Venta</p>
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <p class="text-xs text-gray-500">N° Factura</p>
                  <p class="text-sm font-medium">{{ detalleCuota.numero_factura }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Fecha Venta</p>
                  <p class="text-sm">{{ formatDate(detalleCuota.fecha_venta, false) }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Total Venta</p>
                  <p class="text-sm font-semibold">$ {{ formatNumber(detalleCuota.total_venta_usd) }}</p>
                </div>
                <div v-if="detalleCuota.nombreVendedor">
                  <p class="text-xs text-gray-500">Vendedor</p>
                  <p class="text-sm">{{ detalleCuota.nombreVendedor }}</p>
                </div>
              </div>
            </div>

            <!-- Detalles financieros -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Detalles Financieros</p>
              <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
                <div>
                  <p class="text-xs text-gray-500">Fecha Vencimiento</p>
                  <p class="text-sm" :class="detalleCuota.estaVencida ? 'text-red-600 font-medium' : ''">
                    {{ formatDate(detalleCuota.fecha_vencimiento, false) }}
                    <span v-if="detalleCuota.diasVencidos > 0" class="text-xs block text-red-500">
                      {{ detalleCuota.diasVencidos }} días vencido
                    </span>
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Monto USD</p>
                  <p class="text-sm font-semibold">$ {{ formatNumber(detalleCuota.montoUsd) }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Monto Bs</p>
                  <p class="text-sm">Bs {{ formatNumber(detalleCuota.montoBs) }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Saldo USD</p>
                  <p class="text-sm font-semibold" :class="detalleCuota.saldoUsd > 0 ? 'text-yellow-600' : 'text-green-600'">
                    $ {{ formatNumber(detalleCuota.saldoUsd) }}
                  </p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Saldo Bs</p>
                  <p class="text-sm">Bs {{ formatNumber(detalleCuota.saldoBs) }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500">Fecha Pago</p>
                  <p class="text-sm">{{ detalleCuota.fechaPago ? formatDate(detalleCuota.fechaPago, false) : '—' }}</p>
                </div>
                <div v-if="detalleCuota.interesMoraUsd > 0">
                  <p class="text-xs text-gray-500">Interés Mora USD</p>
                  <p class="text-sm text-orange-600">$ {{ formatNumber(detalleCuota.interesMoraUsd) }}</p>
                </div>
                <div v-if="detalleCuota.interesMoraBs > 0">
                  <p class="text-xs text-gray-500">Interés Mora Bs</p>
                  <p class="text-sm text-orange-600">Bs {{ formatNumber(detalleCuota.interesMoraBs) }}</p>
                </div>
              </div>
            </div>

            <!-- Observaciones -->
            <div v-if="detalleCuota.observaciones" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Observaciones</p>
              <p class="text-sm">{{ detalleCuota.observaciones }}</p>
            </div>

            <!-- Historial de pagos -->
            <div v-if="detalleCuota.historialPagos && detalleCuota.historialPagos.length > 0" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Historial de Pagos</p>
              <div class="space-y-2">
                <div 
                  v-for="pago in detalleCuota.historialPagos" 
                  :key="pago.idPago"
                  class="flex justify-between items-center p-2 bg-white dark:bg-gray-800 rounded border border-gray-200 dark:border-gray-700"
                >
                  <div>
                    <p class="text-xs text-gray-500">{{ formatDate(pago.fechaPago, true) }}</p>
                    <p class="text-sm font-medium">$ {{ formatNumber(pago.monto) }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-xs text-gray-500">{{ pago.metodo_pago }}</p>
                    <p class="text-xs text-gray-500">Ref: {{ pago.referencia || '—' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-end">
          <button
            @click="closeDetallesModal"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE REPORTE -->
    <Teleport to="body">
    <div v-if="showReportModal" class="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-[100] backdrop-blur-[2px]" @click.self="closeReportModal">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-6xl transform transition-all duration-300 scale-100 max-h-[95vh] overflow-hidden mx-auto my-auto flex flex-col">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-green-600 to-emerald-600 flex justify-between items-center">
          <div class="flex items-center text-white">
            <Icon icon="mdi:file-document" class="text-2xl mr-3" />
            <div>
              <h3 class="text-xl font-bold">{{ reporteTitulo }}</h3>
              <p class="text-xs text-green-100">{{ reporteSubtitulo }} • {{ reporteCuotas.length }} cuotas</p>
            </div>
          </div>
          <button @click="closeReportModal" class="p-2 hover:bg-white/30 text-white rounded-lg transition-colors">
            <Icon icon="mdi:close" class="text-2xl" />
          </button>
        </div>

        <div class="px-6 pt-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
          <div class="flex space-x-4">
            <button
              @click="reporteVista = 'lista'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'lista'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:format-list-bulleted" class="mr-2 inline" />
              Vista Lista
            </button>
            <button
              @click="reporteVista = 'resumen'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'resumen'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:chart-bar" class="mr-2 inline" />
              Resumen
            </button>
          </div>
        </div>

        <div class="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-800">
          <div v-if="reporteCargando" class="flex items-center justify-center py-20">
            <div class="animate-spin rounded-full h-12 w-12 border-4 border-green-600 border-t-transparent"></div>
            <p class="ml-4 text-gray-600 dark:text-gray-400">Generando reporte...</p>
          </div>
          <div v-else-if="reporteCuotas.length === 0" class="text-center py-20 text-gray-500">
            No hay cuotas para mostrar en este reporte.
          </div>
          <div v-else>
            <!-- Vista de lista -->
            <div v-if="reporteVista === 'lista'" class="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
              <table class="w-full text-sm">
                <thead class="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Cuota</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Factura</th>

                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Vencimiento</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Monto USD</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Saldo USD</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Estado</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                  <tr v-for="cuota in reporteCuotas" :key="cuota.idCreditoCuota" class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                    <td class="px-4 py-3 font-medium">#{{ cuota.numeroCuota }}</td>
                    <td class="px-4 py-3">{{ cuota.numeroFactura || '—' }}</td>

                    <td class="px-4 py-3">
                      <span :class="estaVencida(cuota) ? 'text-red-600' : ''">
                        {{ formatDate(cuota.fechaVencimiento, false) }}
                      </span>
                    </td>
                    <td class="px-4 py-3">$ {{ formatNumber(cuota.montoUsd) }}</td>
                    <td class="px-4 py-3">
                      <span :class="cuota.saldoUsd > 0 ? 'text-yellow-600' : 'text-green-600'">
                        $ {{ formatNumber(cuota.saldoUsd) }}
                      </span>
                    </td>
                    <td class="px-4 py-3 text-center">
                      <span :class="[
                        'px-2 py-1 text-xs font-semibold rounded-full',
                        obtenerColorEstado(cuota.estado)
                      ]">
                        {{ convertirEstadoATexto(cuota.estado) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Vista de resumen -->
            <div v-else class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Totales Generales</p>
                  <div class="space-y-2">
                    <div class="flex justify-between">
                      <span class="text-sm">Total cuotas:</span>
                      <span class="font-semibold">{{ reporteCuotas.length }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm">Monto total:</span>
                      <span class="font-semibold">$ {{ formatNumber(reporteResumen.montoTotal) }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm">Por cobrar:</span>
                      <span class="font-semibold text-yellow-600">$ {{ formatNumber(reporteResumen.totalPorCobrar) }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm">Pagado:</span>
                      <span class="font-semibold text-green-600">$ {{ formatNumber(reporteResumen.totalPagado) }}</span>
                    </div>
                  </div>
                </div>

                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Distribución por Estado</p>
                  <div class="space-y-2">
                    <div class="flex justify-between">
                      <span class="text-sm flex items-center">
                        <span class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                        Pendientes:
                      </span>
                      <span class="font-semibold">{{ reporteResumen.porEstado?.PENDIENTE || 0 }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm flex items-center">
                        <span class="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                        Pagadas:
                      </span>
                      <span class="font-semibold">{{ reporteResumen.porEstado?.PAGADO || 0 }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm flex items-center">
                        <span class="w-2 h-2 bg-red-500 rounded-full mr-2"></span>
                        Vencidas:
                      </span>
                      <span class="font-semibold">{{ reporteResumen.porEstado?.VENCIDO || 0 }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm flex items-center">
                        <span class="w-2 h-2 bg-gray-500 rounded-full mr-2"></span>
                        Anuladas:
                      </span>
                      <span class="font-semibold">{{ reporteResumen.porEstado?.ANULADO || 0 }}</span>
                    </div>
                  </div>
                </div>

                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Información Adicional</p>
                  <div class="space-y-2">
                    <div class="flex justify-between">
                      <span class="text-sm">Cuotas vencidas:</span>
                      <span class="font-semibold text-red-600">{{ reporteResumen.cuotasVencidas }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm">Total intereses:</span>
                      <span class="font-semibold text-orange-600">$ {{ formatNumber(reporteResumen.totalIntereses) }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-sm">Clientes únicos:</span>
                      <span class="font-semibold">{{ reporteResumen.clientesUnicos }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gráfico de distribución -->
              <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                <p class="text-sm font-medium mb-3">Distribución de Cuotas</p>
                <div class="h-8 flex rounded-lg overflow-hidden">
                  <div 
                    v-if="reporteResumen.porEstado?.PENDIENTE > 0"
                    class="bg-yellow-500 h-full flex items-center justify-center text-xs text-white"
                    :style="{ width: (reporteResumen.porEstado.PENDIENTE / reporteCuotas.length * 100) + '%' }"
                  >
                    {{ Math.round(reporteResumen.porEstado.PENDIENTE / reporteCuotas.length * 100) }}%
                  </div>
                  <div 
                    v-if="reporteResumen.porEstado?.PAGADO > 0"
                    class="bg-green-500 h-full flex items-center justify-center text-xs text-white"
                    :style="{ width: (reporteResumen.porEstado.PAGADO / reporteCuotas.length * 100) + '%' }"
                  >
                    {{ Math.round(reporteResumen.porEstado.PAGADO / reporteCuotas.length * 100) }}%
                  </div>
                  <div 
                    v-if="reporteResumen.porEstado?.VENCIDO > 0"
                    class="bg-red-500 h-full flex items-center justify-center text-xs text-white"
                    :style="{ width: (reporteResumen.porEstado.VENCIDO / reporteCuotas.length * 100) + '%' }"
                  >
                    {{ Math.round(reporteResumen.porEstado.VENCIDO / reporteCuotas.length * 100) }}%
                  </div>
                  <div 
                    v-if="reporteResumen.porEstado?.ANULADO > 0"
                    class="bg-gray-500 h-full flex items-center justify-center text-xs text-white"
                    :style="{ width: (reporteResumen.porEstado.ANULADO / reporteCuotas.length * 100) + '%' }"
                  >
                    {{ Math.round(reporteResumen.porEstado.ANULADO / reporteCuotas.length * 100) }}%
                  </div>
                </div>
                <div class="flex justify-center gap-4 mt-3 text-xs">
                  <span class="flex items-center"><span class="w-2 h-2 bg-yellow-500 rounded-full mr-1"></span> Pendientes</span>
                  <span class="flex items-center"><span class="w-2 h-2 bg-green-500 rounded-full mr-1"></span> Pagadas</span>
                  <span class="flex items-center"><span class="w-2 h-2 bg-red-500 rounded-full mr-1"></span> Vencidas</span>
                  <span class="flex items-center"><span class="w-2 h-2 bg-gray-500 rounded-full mr-1"></span> Anuladas</span>
                </div>
              </div>
            </div>

            <div class="mt-4 text-right text-sm text-gray-600 dark:text-gray-400">
              Total de cuotas: <span class="font-bold">{{ reporteCuotas.length }}</span>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-between items-center">
          <div class="text-xs text-gray-500">
            <Icon icon="mdi:information" class="inline mr-1" />
            Puedes cambiar entre vista lista y vista resumen
          </div>
          <div class="flex space-x-3">
            <button
              @click="closeReportModal"
              class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cerrar
            </button>
            <button
              @click="imprimirReporte"
              class="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 text-sm flex items-center"
            >
              <Icon icon="mdi:printer" class="mr-2 text-lg" />
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE CONFIRMACIÓN -->
    <Teleport to="body">
    <div v-if="showConfirmModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[110] backdrop-blur-[2px]" @click.self="cancelarConfirmacion">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 scale-100 mx-auto my-auto overflow-hidden">
        <div class="px-6 py-4" :class="confirmModalColor">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-white bg-opacity-30 mr-4">
              <Icon :icon="confirmModalIcon" class="text-white text-2xl" />
            </div>
            <div>
              <h3 class="text-lg font-bold text-white">{{ confirmModalTitulo }}</h3>
              <p class="text-sm text-white text-opacity-90">{{ confirmModalSubtitulo }}</p>
            </div>
          </div>
        </div>
        
        <div class="px-6 py-5">
          <p class="text-gray-700 dark:text-gray-300 mb-2">{{ confirmModalMensaje }}</p>
          <p v-if="confirmModalDetalle" class="text-sm text-gray-500 dark:text-gray-400 mb-4">{{ confirmModalDetalle }}</p>

          <div v-if="confirmModalTipo === 'anular' && confirmModalCuota" class="mb-4 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <div class="flex items-center">
              <Icon icon="mdi:alert-circle" class="text-red-600 dark:text-red-400 text-xl mr-2" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">Cuota #{{ confirmModalCuota.numero_cuota }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Factura: {{ confirmModalCuota.numero_factura }}</p>
              </div>
            </div>
            <p class="mt-2 text-xs text-red-600 dark:text-red-400">
              <Icon icon="mdi:alert" class="inline mr-1" />
              Esta acción no se puede deshacer
            </p>
          </div>

          <div v-if="confirmModalTipo === 'toggle-status' && confirmModalCuota" class="mb-4 p-3 rounded-lg" :class="confirmModalCuota.estado === 'VENCIDO' ? 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800' : 'bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800'">
            <div class="flex items-center">
              <Icon :icon="confirmModalCuota.estado === 'VENCIDO' ? 'mdi:clock-alert' : 'mdi:clock-outline'" class="text-xl mr-2" :class="confirmModalCuota.estado === 'VENCIDO' ? 'text-red-600' : 'text-yellow-600'" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">Cuota #{{ confirmModalCuota.numero_cuota }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado actual: {{ convertirEstadoATexto(confirmModalCuota.estado) }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
          <button
            @click="cancelarConfirmacion"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 text-sm"
          >
            Cancelar
          </button>
          <button
            @click="ejecutarAccionConfirmada"
            class="px-4 py-2 rounded-lg text-white font-medium transition-all duration-300 text-sm flex items-center"
            :class="confirmModalButtonColor"
          >
            <Icon v-if="confirmModalCargando" icon="mdi:loading" class="animate-spin mr-2" />
            {{ confirmModalCargando ? 'Procesando...' : confirmModalBotonTexto }}
          </button>
        </div>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { debounce } from 'lodash';
import { useToast } from "vue-toastification";

// APIs
import {
  obtenerCuotasCredito,
  obtenerCuotaPorId,
  crearCuotaCredito,
  actualizarCuotaCredito,
  pagarCuota,
  buscarCuotasAPI,
  obtenerCuotasPorVenta,
  obtenerCuotasPendientes,
  obtenerCuotasVencidas,
  obtenerCuotasPorEstado,
  obtenerResumenCuotasVenta,
  obtenerCuotasPorVencimiento,
  calcularInteresMora,
  formatearFechaVencimiento,
  formatearEstadoCuota,
  getColorPorEstadoCuota,
  estaVencida,
  exportarCuotasExcel,
  exportarCuotasPDF
} from '@/api/creditoCuotas.js';

import { obtenerMetodosPago } from '@/api/metodosPago.api.js';
import { obtenerVentaPorId } from '@/api/ventas.js';

export default {
  name: 'CreditoCuotasView',
  components: {
    Icon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    idVenta: {
      type: Number,
      default: null
    }
  },
  data() {
    const today = new Date().toISOString().split('T')[0];
    return {
      // Datos principales
      cuotas: [],
      metodosPago: [],
      detalleCuota: null,
      ventaSeleccionada: this.idVenta,

      // UI States
      loading: false,
      saving: false,
      pagoSaving: false,
      cargandoDetalles: false,
      showModal: false,
      showPagoModal: false,
      showDetallesModal: false,
      showReportModal: false,
      showConfirmModal: false,
      reporteCargando: false,
      reporteCuotas: [],
      reporteTitulo: '',
      reporteSubtitulo: '',
      reporteVista: 'lista',

      // Filtros y búsqueda
      searchQuery: '',
      filterEstado: 'all',
      fechaDesde: '',
      fechaHasta: '',
      sortBy: 'fecha_vencimiento',
      sortDirection: 'asc',
      currentPage: 1,
      itemsPerPage: 10,
      lastUpdate: new Date(),

      // Cache de ventas para enriquecimiento
      ventasCache: {},
      cargandoVentas: false,

      // Formulario de cuota (adaptado a API camelCase)
      form: {
        idCreditoCuota: null,
        idVenta: this.idVenta || '',
        codigoTipoCredito: '',
        numeroCuota: '',
        fechaVencimiento: '',
        montoUsd: '',
        montoBs: '0',
        saldoUsd: '',
        saldoBs: '0',
        interesMoraUsd: '0',
        interesMoraBs: '0',
        estado: 'PENDIENTE',
        observaciones: ''
      },
      editingCuota: null,
      sortBy: 'fechaVencimiento',
      sortDirection: 'asc',

      // Formulario de pago (adaptado a API camelCase)
      pagoCuota: null,
      pagoInteresMora: 0,
      pagoEsParcial: false,
      pagoForm: {
        idCreditoCuota: null,
        montoUsdPagado: '',
        montoBsPagado: '0',
        fechaPago: today,
        idMetodoPago: '',
        numeroRecibo: '',
        referencia: '', // Extra para UI
        observaciones: '',
        aplicar_interes_mora: true
      },

      // Modales de confirmación
      confirmModalTipo: '',
      confirmModalTitulo: '',
      confirmModalSubtitulo: '',
      confirmModalMensaje: '',
      confirmModalDetalle: '',
      confirmModalIcon: '',
      confirmModalColor: '',
      confirmModalButtonColor: '',
      confirmModalBotonTexto: '',
      confirmModalCuota: null,
      confirmModalCargando: false,
      confirmModalAccion: null,

      // Constantes
      today
    };
  },
  computed: {
    esAdmin() {
      return localStorage.getItem('rol') === 'Administrador';
    },
    filteredCuotas() {
      let filtered = [...this.cuotas];

      // Búsqueda por texto (mejorada para buscar en datos enriquecidos)
      if (this.searchQuery.trim()) {
        const terminoLower = this.searchQuery.toLowerCase();
        filtered = filtered.filter(cuota => 
          (cuota.numeroFactura && cuota.numeroFactura.toLowerCase().includes(terminoLower)) ||
          (cuota.nombreCliente && cuota.nombreCliente.toLowerCase().includes(terminoLower)) ||
          `cuota ${cuota.numeroCuota}`.toLowerCase().includes(terminoLower)
        );
      }

      // Filtro por estado
      if (this.filterEstado !== 'all') {
        filtered = filtered.filter(c => c.estado === this.filterEstado);
      }

      // Filtro por fechas
      if (this.fechaDesde) {
        filtered = filtered.filter(c => c.fechaVencimiento >= this.fechaDesde);
      }
      if (this.fechaHasta) {
        filtered = filtered.filter(c => c.fechaVencimiento <= this.fechaHasta);
      }

      // Ordenar
      filtered.sort((a, b) => {
        let comparison = 0;
        if (this.sortBy === 'numeroCuota') {
          comparison = (a.numeroCuota || 0) - (b.numeroCuota || 0);
        } else if (this.sortBy === 'fechaVencimiento') {
          comparison = new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento);
        } else if (this.sortBy === 'montoUsd') {
          comparison = (a.montoUsd || 0) - (b.montoUsd || 0);
        } else if (this.sortBy === 'saldoUsd') {
          comparison = (a.saldoUsd || 0) - (b.saldoUsd || 0);
        }
        return this.sortDirection === 'asc' ? comparison : -comparison;
      });

      return filtered;
    },

    paginatedCuotas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCuotas.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredCuotas.length / this.itemsPerPage);
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },

    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredCuotas.length);
    },

    resumenTotales() {
      return {
        totalPorCobrarUSD: this.cuotas
          .filter(c => c.estado !== 'PAGADO' && c.estado !== 'ANULADO')
          .reduce((sum, c) => sum + (c.saldoUsd || 0), 0),
        totalPagadoUSD: this.cuotas
          .filter(c => c.estado === 'PAGADO')
          .reduce((sum, c) => sum + (c.montoUsd || 0), 0),
        totalInteresesMoraUSD: this.cuotas
          .reduce((sum, c) => sum + (c.interesMoraUsd || 0), 0),
        cuotasPendientes: this.cuotas.filter(c => c.estado === 'PENDIENTE' && !estaVencida(c)).length,
        cuotasPagadas: this.cuotas.filter(c => c.estado === 'PAGADO').length,
        cuotasVencidas: this.cuotas.filter(c => estaVencida(c)).length,
        cuotasAnuladas: this.cuotas.filter(c => c.estado === 'ANULADO').length
      };
    },

    reporteResumen() {
      const porEstado = this.reporteCuotas.reduce((acc, c) => {
        acc[c.estado] = (acc[c.estado] || 0) + 1;
        return acc;
      }, {});

      return {
        totalCuotas: this.reporteCuotas.length,
        montoTotal: this.reporteCuotas.reduce((sum, c) => sum + (c.montoUsd || 0), 0),
        totalPorCobrar: this.reporteCuotas
          .filter(c => c.estado !== 'PAGADO' && c.estado !== 'ANULADO')
          .reduce((sum, c) => sum + (c.saldoUsd || 0), 0),
        totalPagado: this.reporteCuotas
          .filter(c => c.estado === 'PAGADO')
          .reduce((sum, c) => sum + (c.montoUsd || 0), 0),
        totalIntereses: this.reporteCuotas.reduce((sum, c) => sum + (c.interesMoraUsd || 0), 0),
        cuotasVencidas: this.reporteCuotas.filter(c => estaVencida(c)).length,
        clientesUnicos: new Set(this.reporteCuotas.map(c => c.nombreCliente)).size,
        porEstado
      };
    },

    minDate() {
      const date = new Date();
      return date.toISOString().split('T')[0];
    },

    isFormValid() {
      return this.form.idVenta && 
             this.form.numeroCuota > 0 && 
             this.form.fechaVencimiento && 
             this.form.montoUsd > 0;
    },

    pagoFormValid() {
      return this.pagoForm.montoUsdPagado > 0 && 
             this.pagoForm.fechaPago && 
             this.pagoForm.idMetodoPago;
    }
  },
  watch: {
    filterEstado() {
      this.currentPage = 1;
    },
    fechaDesde() {
      this.currentPage = 1;
    },
    fechaHasta() {
      this.currentPage = 1;
    },
    searchQuery() {
      this.currentPage = 1;
    },
    idVenta: {
      handler(newVal) {
        this.ventaSeleccionada = newVal;
        if (newVal) {
          this.loadCuotasPorVenta(newVal);
        } else {
          this.loadData();
        }
      },
      immediate: true
    },
    'pagoForm.idCuota': {
      async handler(newVal) {
        if (newVal && this.pagoForm.aplicar_interes_mora) {
          await this.calcularInteresParaPago();
        }
      }
    },
    'pagoForm.aplicar_interes_mora': {
      async handler(newVal) {
        if (newVal && this.pagoForm.idCuota) {
          await this.calcularInteresParaPago();
        } else {
          this.pagoInteresMora = 0;
        }
      }
    }
  },
  async mounted() {
    await this.cargarMetodosPago();
    if (!this.idVenta) {
      await this.loadData();
    }
  },
  methods: {
    // ========== MÉTODOS DE CARGA DE DATOS ==========
    async loadData() {
      this.loading = true;
      try {
        const response = await obtenerCuotasCredito();
        
        if (response.success) {
          const cuotasData = response.data || [];
          this.cuotas = cuotasData;
          this.lastUpdate = new Date();
          
          // Enriquecer con información de ventas
          await this.enriquecerCuotasConVentas(cuotasData);
        } else {
          this.mostrarError(response.error || 'Error al cargar las cuotas');
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.mostrarError('Error al cargar los datos');
      } finally {
        this.loading = false;
      }
    },

    async loadCuotasPorVenta(idVenta) {
      this.loading = true;
      try {
        const response = await obtenerCuotasPorVenta(idVenta);
        
        if (response.success) {
          const cuotasData = response.data || [];
          this.cuotas = cuotasData;
          this.lastUpdate = new Date();
          
          // Enriquecer con información de ventas
          await this.enriquecerCuotasConVentas(cuotasData);
        } else {
          this.mostrarError(response.error || 'Error al cargar las cuotas');
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.mostrarError('Error al cargar los datos');
      } finally {
        this.loading = false;
      }
    },

    async enriquecerCuotasConVentas(cuotas) {
      if (!cuotas || cuotas.length === 0) return;
      
      this.cargandoVentas = true;
      try {
        // Identificar IDs de venta únicos que no están en cache
        const idsVentaUnicos = [...new Set(cuotas.map(c => c.idVenta))].filter(id => id && !this.ventasCache[id]);
        
        if (idsVentaUnicos.length > 0) {
          console.log(`🔍 Enriqueciendo ${idsVentaUnicos.length} ventas únicas...`);
          
          // Consultar cada venta (se podría optimizar con un endpoint de batch si existiera)
          // Usamos Promise.all con un límite si fuera necesario, pero para facturas suele ser manejable
          await Promise.all(idsVentaUnicos.map(async (id) => {
            try {
              const res = await obtenerVentaPorId(id);
              if (res.success && res.data) {
                this.ventasCache[id] = {
                  numeroFactura: res.data.numeroFactura,
                  nombreCliente: res.data.clienteNombre || 'Sin Cliente'
                };
              }
            } catch (err) {
              console.warn(`⚠️ No se pudo obtener venta ${id}:`, err);
            }
          }));
        }

        // Inyectar datos en la lista actual
        this.cuotas = this.cuotas.map(cuota => {
          if (cuota.idVenta && this.ventasCache[cuota.idVenta]) {
            return {
              ...cuota,
              numeroFactura: this.ventasCache[cuota.idVenta].numeroFactura,
              nombreCliente: this.ventasCache[cuota.idVenta].nombreCliente
            };
          }
          return cuota;
        });
      } finally {
        this.cargandoVentas = false;
      }
    },

    async cargarMetodosPago() {
      try {
        const response = await obtenerMetodosPago();
        if (response.success) {
          this.metodosPago = response.data || [];
        }
      } catch (error) {
        console.error('Error cargando métodos de pago:', error);
      }
    },

    async cargarDetallesCompletos(id) {
      this.cargandoDetalles = true;
      try {
        const response = await obtenerCuotaPorId(id);

        if (response.success) {
          this.detalleCuota = response.data;
          // Si la API no devuelve pagos en obtenerCuotaPorId, usamos obtenerCuotaConRelaciones
          if (!this.detalleCuota.historialPagos) {
            const relRes = await obtenerCuotaConRelaciones(id);
            if (relRes.success) {
              this.detalleCuota = relRes.data;
            }
          }
        }
      } catch (error) {
        console.error('Error cargando detalles:', error);
        this.mostrarError('Error al cargar los detalles');
      } finally {
        this.cargandoDetalles = false;
      }
    },

    async calcularInteresParaPago() {
      if (!this.pagoForm.idCuota) return;
      
      try {
        const response = await calcularInteresMora(this.pagoForm.idCuota);
        if (response.success) {
          this.pagoInteresMora = response.data || 0;
        }
      } catch (error) {
        console.error('Error calculando interés:', error);
        this.pagoInteresMora = 0;
      }
    },

    // ========== MÉTODOS DE CONFIRMACIÓN ==========
    abrirModalConfirmacion(config) {
      this.confirmModalTipo = config.tipo;
      this.confirmModalTitulo = config.titulo;
      this.confirmModalSubtitulo = config.subtitulo || '';
      this.confirmModalMensaje = config.mensaje;
      this.confirmModalDetalle = config.detalle || '';
      this.confirmModalIcon = config.icon || 'mdi:help-circle';
      this.confirmModalColor = config.color || 'bg-gradient-to-r from-blue-600 to-indigo-600';
      this.confirmModalButtonColor = config.buttonColor || 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700';
      this.confirmModalBotonTexto = config.botonTexto || 'Confirmar';
      this.confirmModalCuota = config.cuota || null;
      this.confirmModalAccion = config.accion;
      this.showConfirmModal = true;
    },

    cancelarConfirmacion() {
      this.showConfirmModal = false;
      this.confirmModalCargando = false;
      this.confirmModalCuota = null;
      this.confirmModalAccion = null;
    },

    async ejecutarAccionConfirmada() {
      if (this.confirmModalAccion) {
        this.confirmModalCargando = true;
        await this.confirmModalAccion(this.confirmModalCuota);
        this.confirmModalCargando = false;
        this.cancelarConfirmacion();
      }
    },

    abrirModalAnular(cuota) {
      this.abrirModalConfirmacion({
        tipo: 'anular',
        titulo: 'Anular Cuota',
        subtitulo: 'Esta acción no se puede deshacer',
        mensaje: `¿Estás seguro de anular la cuota #${cuota.numero_cuota}?`,
        detalle: 'La cuota será marcada como anulada y no podrá ser utilizada.',
        icon: 'mdi:cancel',
        color: 'bg-gradient-to-r from-red-600 to-pink-600',
        buttonColor: 'bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700',
        botonTexto: 'Anular',
        cuota: cuota,
        accion: this.anularCuotaConfirmada
      });
    },

    abrirModalToggleStatus(cuota) {
      if (cuota.estado === 'VENCIDO') {
        this.toast.info('Las cuotas vencidas solo pueden ser pagadas o anuladas');
        return;
      }
      // No hay toggle de estado, solo información
    },

    // ========== MÉTODOS DE TOAST ==========
    mostrarExito(mensaje) {
      this.toast.success(mensaje, { timeout: 3000 });
    },

    mostrarError(mensaje) {
      this.toast.error(mensaje, { timeout: 5000 });
    },

    mostrarAdvertencia(mensaje) {
      this.toast.warning(mensaje, { timeout: 4000 });
    },

    // ========== MÉTODOS DE FORMATEO ==========
    formatNumber(numero, decimales = 2) {
      if (numero === null || numero === undefined) return '0,00';
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(numero);
    },

    formatDate(fechaISO, completo = true) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        const opciones = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        if (completo) {
          opciones.hour = '2-digit';
          opciones.minute = '2-digit';
        }
        return fecha.toLocaleDateString('es-VE', opciones);
      } catch (error) {
        return fechaISO;
      }
    },

    formatTime(fechaISO) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        return fecha.toLocaleTimeString('es-VE', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } catch (error) {
        return '';
      }
    },

    estaVencida(cuota) {
      return estaVencida(cuota);
    },

    convertirEstadoATexto(estado) {
      return formatearEstadoCuota(estado);
    },

    async eliminarCuota(cuota) {
      this.abrirModalConfirmacion({
        tipo: 'eliminar',
        titulo: 'ELIMINAR CUOTA',
        subtitulo: '¡ACCIÓN IRREVERSIBLE!',
        mensaje: `¿Estás completamente seguro de ELIMINAR la cuota #${cuota.numeroCuota}?`,
        detalle: 'Se eliminarán también todos los pagos asociados a esta cuota física y permanentemente de la base de datos.',
        icon: 'mdi:trash-can-alert',
        color: 'bg-gradient-to-r from-red-700 to-rose-700',
        buttonColor: 'bg-gradient-to-r from-red-700 to-rose-700 hover:from-red-800 hover:to-rose-800',
        botonTexto: 'ELIMINAR PERMANENTEMENTE',
        cuota: cuota,
        accion: async (c) => {
          try {
            const { eliminarCuotaCredito } = await import('@/api/creditoCuotas.js');
            const res = await eliminarCuotaCredito(c.idCuota || c.idCreditoCuota);
            if (res.success) {
              this.mostrarExito('Cuota y pagos eliminados correctamente');
              await this.loadData();
            } else {
              this.mostrarError(res.error || 'No se pudo eliminar la cuota');
            }
          } catch (e) {
            this.mostrarError('Error: ' + e.message);
          }
        }
      });
    },

    obtenerColorEstado(estado) {
      return getColorPorEstadoCuota(estado);
    },

    obtenerIconoEstado(estado) {
      switch (estado?.toLowerCase()) {
        case 'pagada':
        case 'pagado':
          return 'mdi:check-circle';
        case 'pendiente':
          return 'mdi:clock-outline';
        case 'vencida':
        case 'vencido':
          return 'mdi:alert-circle';
        case 'anulada':
        case 'anulado':
          return 'mdi:cancel';
        default:
          return 'mdi:help-circle';
      }
    },

    // ========== MÉTODOS DE FILTROS ==========
    handleFilterChange() {
      this.currentPage = 1;
    },

    handleSearch: debounce(function() {
      this.currentPage = 1;
    }, 300),

    clearFilters() {
      this.searchQuery = '';
      this.filterEstado = 'all';
      this.fechaDesde = '';
      this.fechaHasta = '';
      this.sortBy = 'fechaVencimiento';
      this.sortDirection = 'asc';
      this.currentPage = 1;
    },

    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = column;
        this.sortDirection = 'asc';
      }
    },

    // ========== MÉTODOS DE REPORTES ==========
    async generarReporteGeneral() {
      const result = await exportarCuotasExcel(this.cuotas, 'reporte_general_cuotas');
      if (result.success) {
        this.mostrarExito('Reporte Excel generado');
      }
    },

    async generarReportePDF() {
      const result = await exportarCuotasPDF(this.filteredCuotas, 'Reporte de Cuotas');
      if (result.success) {
        this.mostrarExito('Reporte PDF generado');
      }
    },

    generarReportePorFiltro(tipoFiltro, tituloPersonalizado = null) {
      let cuotasFiltradas = [];
      
      if (tipoFiltro === 'vencimiento-semana') {
        const hoy = new Date();
        const semana = new Date(hoy);
        semana.setDate(semana.getDate() + 7);
        cuotasFiltradas = this.cuotas.filter(c => {
          const vencimiento = new Date(c.fechaVencimiento);
          return vencimiento >= hoy && vencimiento <= semana && c.estado === 'PENDIENTE';
        });
      } else if (tipoFiltro === 'mora') {
        cuotasFiltradas = this.cuotas.filter(c => c.interesMoraUsd > 0);
      } else {
        cuotasFiltradas = this.cuotas.filter(c => c.estado === tipoFiltro);
      }
      
      if (cuotasFiltradas.length === 0) {
        this.toast.warning('No hay cuotas que coincidan con este filtro');
        return;
      }
      
      this.reporteTitulo = tituloPersonalizado || `CUOTAS: ${tipoFiltro}`;
      this.reporteSubtitulo = `Filtro: ${tipoFiltro}`;
      this.reporteCuotas = cuotasFiltradas;
      this.reporteVista = 'lista';
      this.showReportModal = true;
    },

    closeReportModal() {
      this.showReportModal = false;
      this.reporteCuotas = [];
      this.reporteVista = 'lista';
    },

    imprimirReporte() {
      this.toast.info('Función de impresión en desarrollo');
    },

    // ========== MÉTODOS DE MODALES ==========
    openGenerarCuotasModal() {
      // Aquí iría el modal para generar cuotas desde una venta
      this.toast.info('Función de generación de cuotas en desarrollo');
    },

    abrirModalEditar(cuota) {
      this.editingCuota = cuota;
      
      this.form = {
        idCreditoCuota: cuota.idCreditoCuota,
        idVenta: cuota.idVenta,
        codigoTipoCredito: cuota.codigoTipoCredito,
        numeroCuota: cuota.numeroCuota,
        fechaVencimiento: cuota.fechaVencimiento,
        montoUsd: cuota.montoUsd,
        montoBs: cuota.montoBs || 0,
        saldoUsd: cuota.saldoUsd,
        saldoBs: cuota.saldoBs || 0,
        interesMoraUsd: cuota.interesMoraUsd || 0,
        interesMoraBs: cuota.interesMoraBs || 0,
        estado: cuota.estado,
        observaciones: cuota.observaciones || ''
      };
      
      this.showModal = true;
    },

    abrirModalPagar(cuota) {
      this.pagoCuota = cuota;
      this.pagoForm = {
        idCreditoCuota: cuota.idCreditoCuota,
        montoUsdPagado: cuota.saldoUsd,
        montoBsPagado: '0',
        fechaPago: this.today,
        idMetodoPago: '',
        numeroRecibo: '',
        referencia: '',
        observaciones: `Pago de cuota #${cuota.numeroCuota} - Factura: ${cuota.numeroFactura}`,
        aplicar_interes_mora: true
      };
      this.pagoEsParcial = false;
      this.pagoInteresMora = 0;
      this.showPagoModal = true;
      
      // Calcular interés si aplica
      if (estaVencida(cuota)) {
        this.calcularInteresParaPago();
      }
    },

    abrirModalPagarParcial(cuota) {
      this.pagoCuota = cuota;
      this.pagoForm = {
        idCreditoCuota: cuota.idCreditoCuota,
        montoUsdPagado: '',
        montoBsPagado: '0',
        fechaPago: this.today,
        idMetodoPago: '',
        numeroRecibo: '',
        referencia: '',
        observaciones: `Pago parcial cuota #${cuota.numeroCuota} - Factura: ${cuota.numeroFactura}`,
        aplicar_interes_mora: true
      };
      this.pagoEsParcial = true;
      this.pagoInteresMora = 0;
      this.showPagoModal = true;
      
      if (estaVencida(cuota)) {
        this.calcularInteresParaPago();
      }
    },

    abrirModalVerDetalles(cuota) {
      this.detalleCuota = null;
      this.showDetallesModal = true;
      this.cargarDetallesCompletos(cuota.idCuota);
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    closePagoModal() {
      this.showPagoModal = false;
      this.pagoCuota = null;
      this.pagoInteresMora = 0;
      this.pagoForm = {
        idCreditoCuota: null,
        montoUsdPagado: '',
        montoBsPagado: '0',
        fechaPago: this.today,
        idMetodoPago: '',
        numeroRecibo: '',
        referencia: '',
        observaciones: '',
        aplicar_interes_mora: true
      };
    },

    closeDetallesModal() {
      this.showDetallesModal = false;
      this.detalleCuota = null;
    },

    resetForm() {
      this.form = {
        idCreditoCuota: null,
        idVenta: this.idVenta || '',
        codigoTipoCredito: '',
        numeroCuota: '',
        fechaVencimiento: '',
        montoUsd: '',
        montoBs: '0',
        saldoUsd: '',
        saldoBs: '0',
        interesMoraUsd: '0',
        interesMoraBs: '0',
        estado: 'PENDIENTE',
        observaciones: ''
      };
      this.editingCuota = null;
    },

    // ========== VALIDACIONES ==========
    validateForm() {
      if (!this.form.idVenta) {
        this.mostrarError('El ID de venta es requerido');
        return false;
      }
      if (!this.form.numero_cuota || this.form.numero_cuota <= 0) {
        this.mostrarError('El número de cuota debe ser mayor a 0');
        return false;
      }
      if (!this.form.fecha_vencimiento) {
        this.mostrarError('La fecha de vencimiento es requerida');
        return false;
      }
      if (!this.form.monto_usd || this.form.monto_usd <= 0) {
        this.mostrarError('El monto debe ser mayor a 0');
        return false;
      }
      return true;
    },

    // ========== MÉTODOS CRUD ==========
    async saveCuota() {
      if (!this.validateForm()) return;

      this.saving = true;
      try {
        const cuotaData = {
          idCreditoCuota: this.form.idCreditoCuota,
          idVenta: parseInt(this.form.idVenta),
          codigoTipoCredito: this.form.codigoTipoCredito,
          numeroCuota: parseInt(this.form.numeroCuota),
          fechaVencimiento: this.form.fechaVencimiento,
          montoUsd: parseFloat(this.form.montoUsd),
          montoBs: parseFloat(this.form.montoBs || 0),
          saldoUsd: parseFloat(this.form.saldoUsd || this.form.montoUsd),
          saldoBs: parseFloat(this.form.saldoBs || this.form.montoBs || 0),
          interesMoraUsd: parseFloat(this.form.interesMoraUsd || 0),
          interesMoraBs: parseFloat(this.form.interesMoraBs || 0),
          estado: this.form.estado,
          observaciones: this.form.observaciones || ''
        };

        let result;
        if (this.editingCuota) {
          result = await actualizarCuotaCredito(this.editingCuota.idCreditoCuota, cuotaData);
        } else {
          result = await crearCuotaCredito(cuotaData);
        }

        if (result.success) {
          await this.loadData();
          this.closeModal();
          this.mostrarExito(this.editingCuota ? '¡Cuota actualizada!' : '¡Cuota creada!');
        } else {
          throw new Error(result.error || 'Error al guardar la cuota');
        }
      } catch (error) {
        console.error('Error al guardar:', error);
        this.mostrarError(error.message || 'Error al guardar la cuota');
      } finally {
        this.saving = false;
      }
    },

    async anularCuotaConfirmada(cuota) {
      try {
        const result = await actualizarCuotaCredito(cuota.idCreditoCuota, {
          estado: 'ANULADO',
          observaciones: (cuota.observaciones || '') + ' [ANULADA MANUALMENTE]'
        });

        if (result.success) {
          await this.loadData();
          this.mostrarExito('¡Cuota anulada exitosamente!');
        } else {
          throw new Error(result.error || 'Error al anular la cuota');
        }
      } catch (error) {
        console.error('Error al anular:', error);
        this.mostrarError(error.message || 'Error al anular la cuota');
      }
    },

    async procesarPago() {
      if (!this.pagoFormValid) {
        this.mostrarError('Por favor completa todos los campos requeridos');
        return;
      }

      this.pagoSaving = true;
      try {
        const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
        const pagoData = {
          idCreditoCuota: this.pagoCuota.idCreditoCuota,
          montoUsdPagado: parseFloat(this.pagoForm.montoUsdPagado),
          montoBsPagado: parseFloat(this.pagoForm.montoBsPagado || 0),
          fechaPago: this.pagoForm.fechaPago,
          idMetodoPago: parseInt(this.pagoForm.idMetodoPago),
          numeroRecibo: this.pagoForm.referencia || '',
          idUsuario: usuario.idUsuario || 1,
          observaciones: this.pagoForm.observaciones || '',
          aplicarInteresMora: this.pagoForm.aplicar_interes_mora
        };

        const result = await pagarCuota(pagoData);

        if (result.success) {
          await this.loadData();
          this.closePagoModal();
          this.mostrarExito('¡Pago registrado exitosamente!');
        } else {
          throw new Error(result.error || 'Error al registrar el pago');
        }
      } catch (error) {
        console.error('Error al procesar pago:', error);
        this.mostrarError(error.message || 'Error al procesar el pago');
      } finally {
        this.pagoSaving = false;
      }
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dark ::-webkit-scrollbar-track {
  background: #374151;
}

.dark ::-webkit-scrollbar-thumb {
  background: #6b7280;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media (max-width: 768px) {
  button {
    min-height: 44px;
  }
  
  input, select, textarea {
    font-size: 16px !important;
  }
}

/* Estilos para la tabla responsiva */
@media (max-width: 640px) {
  table {
    font-size: 12px;
  }
  
  td, th {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>